<template>
  <b-row>
    <b-col>
      <div
        v-if="!tableData.length && fetchingTiming"
        class="py-3 text-center"
      >
        <b-spinner />
      </div>
      <div v-else>
        <div class="d-flex justify-content-end mb-1">
          <b-button
            v-if="!isEnded"
            variant="bg-white"
            :disabled="refreshing || fetchingTiming"
            @click="refresh"
          >
            <GjIcon
              name="Refresh"
              class="icon-left"
            />
            Refresh
          </b-button>
        </div>

        <div
          class="d-lg-none"
          :class="{ 'opacity-7': fetchingTiming }"
        >
          <timing-logs-list :logs="tableData" />
        </div>

        <div class="d-none d-lg-block">
          <b-table
            ref="table"
            :items="tableData"
            :fields="fields"
            responsive
            class="loaded border-default border-b border-r border-l rounded"
            :busy="fetchingTiming"
          >
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(startDateTime)="data">
              {{ formatDateTimeDetailed(data.value) }}
            </template>
          </b-table>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import TimingLogsList from '../components/TimingLogsList.vue'

export default {
  name: 'GeneralTimingLogs',
  components: {
    TimingLogsList,
  },
  props: {
    isEnded: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: true,
      required: true,
    },
  },
  data() {
    return {
      refreshing: false,
      initialized: false,
      fields: [
        { key: 'index', label: '' },
        'status',
        { key: 'messageComment', label: 'message' },
        { key: 'startDateTime', label: 'timestamp' },
      ],
      tableData: [],
      fetchingTiming: false,
    }
  },
  watch: {
    visible(val) {
      if (val && !this.initialized) {
        this.initialized = true
        this.fetchTiming()
      }
    },
  },
  methods: {
    refresh() {
      this.fetchTiming()
    },
    fetchTiming() {
      this.fetchingTiming = true
      this.$store.dispatch('jobs/getJobTiming', {
        jobId: this.$route.params.name,
      }).then(res => {
        this.fetchingTiming = false
        this.tableData = res.data.result
      }).catch(() => {
        this.fetchingTiming = false
      })
    },
  },
}
</script>

<style>
  .header-class{
    padding: 16px 0;
  }
</style>
